import { actionTypes } from "../Actions/bairro.action";

const initialState = {
  districts: {
    data: [],
  },
  district: {},
  success: false,
  error: {},
};

// eslint-disable-next-line
export default (state = initialState, { type, payLoad }) => {
  switch (type) {
    case actionTypes.INDEX:
      return {    ...state,
        districts: {
          ...state.districts,
          data: payLoad,
        },};
    case actionTypes.DESTROY:
      return {
        ...state,
        districts: {
          ...state.districts,
          data: state.districts.data.filter((item) => item.id !== payLoad),
        },
      };
    case actionTypes.CHANGE:
      return {
        ...state,
        district: {
          ...state.district,
          ...payLoad,
        },
      };
    case actionTypes.SUCCESS:
      return { ...state, success: payLoad };
    case actionTypes.ERROR:
      return {
        ...state,
        error: payLoad,
      };
    default:
      return state;
  }
};
